module.exports = __webpack_public_path__ + "static/img/d22_bg.b25e26f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/d22_bg.jpg
// module id = Mypm
// module chunks = 1